<template>
  <div class="paragraph-container">
    <div class="quesName">
      <span
        class="question-name-text"
        v-html="formattedQuestionName"
        @click="handleHtmlClick"
      ></span>
      <!-- <span class="starRed" >*</span> -->
    </div>
    <!-- 图片预览 -->
    <van-image-preview
      v-model="showPreview"
      :images="previewImageUrl"
      @close="handleClose"
    />
  </div>
  <!-- <div class="questionContainer">ssss</div> -->
</template>

<script>
export default {
  props: {
    //当前题目的所有相关信息
    previewOption: {
      type: Object,
    },
  },
  created() {
    this.paragraphOption = this.previewOption;
  },
  data() {
    return {
      paragraphOption: {},
      paragraphOption1: {
        name: "段落题目",
      },
      previewImageUrl: [],
      showPreview: false,
    };
  },
  computed: {
    formattedQuestionName() {
      console.log(this.paragraphOption.name, "this.mulSelectOption.name");

      let htmlContent = this.paragraphOption.name || "";

      // 如果包含img标签，则设置图片大小为100px
      if (htmlContent.includes("<img")) {
        // 使用正则表达式匹配所有img标签并添加样式
        htmlContent = htmlContent.replace(/<img(.*?)>/g, (match, p1) => {
          // 检查是否已存在style属性
          if (p1.includes("style=")) {
            // 如果已存在style属性，在原有样式基础上添加width和height
            return match.replace(
              /style="(.*?)"/,
              'style="$1; width: 80px; height: 60px;"'
            );
          } else {
            // 如果不存在style属性，添加新的style属性
            return `<img${p1} style="width: 85px; height: 60px; margin:0px 5px">`;
          }
        });
      }

      return htmlContent;
    },
  },
  methods: {
    handleClose() {
      this.showPreview = false;
    },
    // 添加：处理HTML内容点击事件
    handleHtmlClick(event) {
      console.log(event, "wwwwwwwwwwwww");
      if (event.target.tagName === "IMG") {
        this.previewImageUrl = event.target.src.split(",");
        // this.imagePreviewVisible = true;
        this.showPreview = true;
      }
    },
    doValided() {
      return false;
    },
    doValidedFlag() {
      return true;
    },
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus">
.paragraph-container {
  padding: 10px;

  .quesName {
    font-size: 18px;
    font-weight: 500;
    padding: 10px;
  }

  .question-name-text {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #353535;
  }

  .starRed {
    color: red;
    font-weight: 600;
  }

  .questionContainer {
    padding: 20px 0px 0px 0px;
  }
}
</style>